'use strict';

var $requestPromiseModule = require("request-promise");
var $cookiesModule = require('browser-cookies');

export default {
  $request: $requestPromiseModule,
  $cookies: $cookiesModule,
  $api_url : "https://kalkulacka.prumyslovaizolace.com/api/client/",
  get: function ($method) {
    var options = {
        uri: window.API.$api_url + $method,
        headers: {
            //'User-Agent': 'HN-WebClient'
        },
        json: true
    };
    if (this.$cookies.get("systherm_token") !== null) {
        options.headers['Authorization'] = "Basic " + btoa("1:" + this.$cookies.get("systherm_token"));
        options.headers['AuthToken'] = this.$cookies.get("systherm_token");
    }
    return this.$request(options);
  },
  post: function($method, $data) {
    var options = {
        method: 'POST',
        uri: window.API.$api_url + $method,
        body: $data,
        json: true,
        headers: {
            //'User-Agent': 'HN-WebClient'
        }
    };
    if (this.$cookies.get("systherm_token") !== null) {
        options.headers['Authorization'] = "Basic " + btoa("1:" + this.$cookies.get("systherm_token"));
        options.headers['AuthToken'] = this.$cookies.get("systherm_token");
    }
    return this.$request(options);
  },
  put: function($method, $data) {
    var options = {
        method: 'PUT',
        uri: window.API.$api_url + $method,
        body: $data,
        json: true,
        headers: {
            //'User-Agent': 'HN-WebClient'
        }
    };
    if (this.$cookies.get("systherm_token") !== null) {
        options.headers['Authorization'] = "Basic " + btoa("1:" + this.$cookies.get("systherm_token"));
        options.headers['AuthToken'] = this.$cookies.get("systherm_token");
    }
    return this.$request(options);
  },
  delete: function($method, $data) {
    var options = {
        method: 'DELETE',
        uri: window.API.$api_url + $method,
        json: true,
        headers: {
            //'User-Agent': 'HN-WebClient'
        }
    };
    if (this.$cookies.get("systherm_token") !== null) {
        options.headers['Authorization'] = "Basic " + btoa("1:" + this.$cookies.get("systherm_token"));
        options.headers['AuthToken'] = this.$cookies.get("systherm_token");
    }
    return this.$request(options);
  },
  $setCookie: function($name, $value, $opts) {
    this.$cookies.set($name, $value, $opts);
  }
}



// WEBPACK FOOTER //
// ./src/assets/api.js